import React from "react";
import {Container} from "react-bootstrap";

function STCContainer(props){

    return(
        <Container
            style={props.style}
            className={props.className}

            as={props.as}
            fluid={props.fluid}
            bsPrefix={props.bsPrefix}
        >
            {props.children}
        </Container>
    )
}
export default STCContainer;